// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1632":"18ac4d4aee9d647f","2888":"da2ddc49c73640d8","6948":"67393158117540e3"}[chunkId] + ".css";
};